import React, { useEffect, useState, useRef } from "react";
import AppLayout from "@/Layouts/AppLayout";
import "react-datepicker/dist/react-datepicker.css";
import Row from "@/Components/Questions/Row";
import { usePage } from "@inertiajs/inertia-react";
import { LoadingProvider, useLoading } from "@/Contexts/LoadingContext";
import OrganizationLayout from "@/Layouts/OrganizationLayout";
import LayoutIcon from "@/Components/LayoutIcon";
import { Teams } from "@/Icons";

import { Dropdown, EmptyState } from "@/Components";
import {
  LabeledMultiSelectAutocomplete,
  LabeledSelect,
  LabeledInput,
} from "@/Components/Form";
import { Inertia } from "@inertiajs/inertia";

export default function EmissionsReporter({ questions }) {
  const [questionEmissions, setQuestionEmissions] = useState(null);
  const [searchTimeout, setSearchTimeout] = useState(null);
  const teams = usePage().props?.teams?.data || [];
  const initialLoad = useRef(true);
  const { setIsLoaded } = useLoading();
  const tags = usePage().props?.tags?.data || [];

  const [filter, setFilter] = useState({
    team: "",
    tags: [],
    search: "",
    sort: "title.asc",
  });

  const sortOptions = [
    { value: "title.asc", label: "Name A-Ö" },
    { value: "title.desc", label: "Name Ö-A" },
    { value: "sortableTeams.asc", label: "Team A-Ö" },
    { value: "sortableTeams.desc", label: "Team Ö-A" },
    { value: "created_at.desc", label: "Newest" },
    { value: "created_at.asc", label: "Oldest" },
    { value: "reported.desc", label: "Reported most recent" },
    { value: "reported.asc", label: "Reported least recent" },
  ];
  const teamOptions = [
    { value: "", label: "All teams" },
    ...teams.map((team) => ({
      value: team.id,
      label: team.name,
    })),
  ];

  useEffect(() => {
    if (initialLoad.current === true) {
      initialLoad.current = false;
      if (!questionEmissions) {
        setIsLoaded(false);
        // Fetch data for all questions
        axios
          .post(route("teams.questions.emissions.data"), {
            questions: questions.data.map((q) => q.id),
            teams: teams.map((t) => t.id),
          })
          .then((res) => {
            setQuestionEmissions(res.data);
            setIsLoaded(true);
          });
      }

      return;
    }
    Inertia.put(
      route("reporter.overview.post"),
      { filters: filter },
      {
        preserveState: true,
        preserveScroll: true,
        onSuccess: (page) => {
          // console.log('success', page);
        },
      },
    );
  }, [filter]);

  const changeFilter = (type, value) => {
    setFilter({
      ...filter,
      [type]: value,
    });
  };

  const getTeamByQuestion = (question) => {
    return teams.find((t) => t.id === question?.pivot?.team_id);
  };

  function showFilteredQuestion(question, id) {
    const team = getTeamByQuestion(question);
    if (!team?.id) {
      return null;
    }
    return (
      <Row
        key={`question_${id}`}
        team={team}
        question={question}
        isNew={false}
        // onDelete={(question, team) => setDeletingQuestionId({ question, team })}
        emission={questionEmissions?.[question.id]}
        isReporter={true}
      />
    );
  }

  return (
    <>
      <div className="flex flex-col items-stretch">
        <div className="flex flex-col gap-4 p-4">
          <div className="flex flex-col items-center justify-between gap-4 md:flex-row">
            <div className="w-full min-w-32 md:w-1/4">
              {teamOptions.length > 0 && (
                <LabeledSelect
                  title="Team"
                  options={teamOptions}
                  noDefault={true}
                  onChange={(e) => {
                    changeFilter("team", e.target.value);
                  }}
                />
              )}
            </div>
            <div className="w-full min-w-32 md:w-1/4">
              <LabeledMultiSelectAutocomplete
                title="Categories and modules"
                options={[
                  { value: "other", label: "Other" },
                  ...tags.map((tag) => ({
                    value: tag.id,
                    label: tag.name,
                  })),
                ]}
                value={filter.tags}
                onSelect={(e) => {
                  // console.log("e", e);
                  changeFilter("tags", e);
                }}
                initialChecked={true}

                // title="Choose categories"
                // options={tags?.data.map(t => ({ label: t.name, value: t.id })) || []}
                // value={activityRequest.tags}
                // onChange={(items) => handleFormUpdate({ target: { name: 'tags', value: items } })}
                // titleRight={<InertiaLink href="/categories" className="mb-1 underline">Create new</InertiaLink>}
              />
            </div>
            <div className="w-full min-w-32 md:w-1/4">
              <LabeledInput
                title="Search"
                className="px-2"
                placeholder="Search"
                onChange={(e) => {
                  clearTimeout(searchTimeout);
                  setSearchTimeout(
                    setTimeout(() => {
                      changeFilter("search", e.target.value);
                    }, 500),
                  );
                }}
              />
            </div>
            <div className="flex w-full min-w-20 justify-end pt-8 md:w-1/4">
              <Dropdown
                options={sortOptions}
                title="Sort on"
                placeholder="Name"
                onSelect={(id) => changeFilter("sort", id)}
              />
            </div>
          </div>

          {questions.data.length === 0 ? (
            <EmptyState
              title="You have no activities for the selected team"
              text="To start reporting an admin needs to assign you to some activities."
            />
          ) : (
            <div className="flex flex-col gap-1">
              {questions.data.map((question) =>
                showFilteredQuestion(question, question.id),
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

EmissionsReporter.layout = (page) => (
  <AppLayout title="Emission Accounting">
    <OrganizationLayout
      header="Reporting"
      icon={
        <LayoutIcon>
          <Teams size={40} className="text-black" />
        </LayoutIcon>
      }
      byline="Here you can see all tasks that need to be reported on."
    >
      <LoadingProvider>{page}</LoadingProvider>
    </OrganizationLayout>
  </AppLayout>
);
